import { STORE_TYPES_FOR_SELECT } from '@constants/generic-constants';
import { strings } from '@constants/strings.js';

export const storeUploadsTableColumns = () => [
  {
    title: strings.store_details,
    dataIndex: strings.store_details,
    width: 270,
  },
  {
    title: strings.logo,
    dataIndex: strings.logo,
    width: 160,
  },
  {
    title: strings.banner,
    dataIndex: strings.banner,
    width: 320,
  },
  {
    title: strings.mobile_banner,
    dataIndex: strings.mobile_banner,
    width: 320,
  },
  {
    title: strings.actions,
    dataIndex: strings.actions,
    width: 200,
    fixed: 'right',
  },
];

export const UPLOADS_MODERATION_FILTERS_LIST = [
  {
    type: 'dropdown',
    key: 'f[store_type]',
    placeholder: 'Is Test Account?',
    chipDisplayName: 'Test Account',
    options: STORE_TYPES_FOR_SELECT,
  },
];
